/*
================================================================================
|                                                                              |
|  FILE: src/components/common/Footer.js                                       |
|  PURPOSE: The main footer component for the entire site.                     |
|  NOTE: Updated with the official company logo.                               |
|                                                                              |
================================================================================
*/
import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
    return (
        <footer className="bg-gray-900 text-white">
            <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:py-16 lg:px-8">
                <div className="xl:grid xl:grid-cols-3 xl:gap-8">
                    <div className="space-y-8 xl:col-span-1">
                        <Link to="/" className="flex items-center">
                            {/* Updated Logo */}
                            <img className="h-12 object-contain" src="/images/imgi_3_logo-white-min.png" alt="Milliardi Energo Logo" />
                        </Link>
                        <p className="text-gray-400 text-base">
                            Engineering the future of energy with innovation, safety, and sustainability at our core.
                        </p>
                    </div>
                    <div className="mt-12 grid grid-cols-2 gap-8 xl:mt-0 xl:col-span-2">
                        <div className="md:grid md:grid-cols-2 md:gap-8">
                            <div>
                                <h3 className="text-sm font-semibold text-gray-300 tracking-wider uppercase">Solutions</h3>
                                <ul className="mt-4 space-y-4">
                                    <li><Link to="/services/environmental" className="text-base text-gray-400 hover:text-white">Environmental Recovery</Link></li>
                                    <li><Link to="/services/oil-gas" className="text-base text-gray-400 hover:text-white">Oil & Gas Solutions</Link></li>
                                    <li><Link to="/services/mining" className="text-base text-gray-400 hover:text-white">Mining and Logistics</Link></li>
                                </ul>
                            </div>
                            <div className="mt-12 md:mt-0">
                                <h3 className="text-sm font-semibold text-gray-300 tracking-wider uppercase">Company</h3>
                                <ul className="mt-4 space-y-4">
                                    <li><Link to="/about" className="text-base text-gray-400 hover:text-white">About</Link></li>
                                    <li><Link to="/news" className="text-base text-gray-400 hover:text-white">News</Link></li>
                                    <li><a href="#" className="text-base text-gray-400 hover:text-white">Careers</a></li>
                                </ul>
                            </div>
                        </div>
                        <div className="md:grid md:grid-cols-1 md:gap-8">
                            <div>
                                <h3 className="text-sm font-semibold text-gray-300 tracking-wider uppercase">Legal</h3>
                                <ul className="mt-4 space-y-4">
                                    <li><a href="#" className="text-base text-gray-400 hover:text-white">Privacy</a></li>
                                    <li><a href="#" className="text-base text-gray-400 hover:text-white">Terms</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="mt-12 border-t border-gray-700 pt-8">
                    <p className="text-base text-gray-400 text-center">
                        &copy; {new Date().getFullYear()} Milliardi Energo. All rights reserved. | 
                        Powered by <a href="https://batistasimons.com" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white transition-colors">Cimons Technologies</a>
                    </p>
                </div>
            </div>
        </footer>
    );
}
